import React from 'react';
import { CompletionAndDismantling, PlanForConduct } from '../../api';
import PersonAndAddressDetailsSection from './planforconduct/PersonAndAddressDetails';
import WorkplaceInfosection from './planforconduct/WorkplaceInfo';
import InfoAboutFinishedScaffoldingSection from './planforconduct/InfoAboutFinishedScaffolding';
import InfoAboutScaffoldingUnderWeatherProtectionSection from './planforconduct/InfoAboutScaffoldingUnderWeatherProtection';
import CompletionAndDismantlingSection from './planforconductpagetwo/CompletionAndDismantling';
import STBAttachmentsSection from './planforconductpagetwo/STBAttachments';
import TaskInfoSection from './planforconductpagetwo/TaskInfo';

interface PlanForConductProp {
    planForConduct: PlanForConduct;
    setPlanForConduct?: React.Dispatch<React.SetStateAction<PlanForConduct | undefined>>;
    isWeatherProtectionProject?: boolean;
}

const PlanForConductTemplate: React.FC<PlanForConductProp> = (props) => {
    const handleCompletionAndDismantlingChange = (updatedData: Partial<CompletionAndDismantling>) => {
        props.setPlanForConduct?.((prevState) => {
            if (!prevState) {
                return prevState;
            }

            return {
                ...prevState,
                completionAndDismantling: {
                    ...prevState.completionAndDismantling,
                    ...updatedData,
                },
            };
        });
    };

    return (
        <div className=''>
            <PersonAndAddressDetailsSection personAndAddressDetails={(props.planForConduct?.personAndAddressDetails ?? {}) as any} />
            <WorkplaceInfosection workplaceInfo={(props.planForConduct?.workplaceInfo ?? {}) as any} />
            <InfoAboutFinishedScaffoldingSection
                infoAboutFinishedScaffolding={(props.planForConduct?.finishedScaffoldInfo ?? {}) as any}
                isWeatherProtectionProject={props.isWeatherProtectionProject}
            />
            <InfoAboutScaffoldingUnderWeatherProtectionSection
                infoAboutScaffoldingUnderWeatherProtection={(props.planForConduct?.weatherProtection ?? {}) as any}
                isWeatherProtectionProject={props.isWeatherProtectionProject}
            />
            <CompletionAndDismantlingSection
                completionAndDismantling={(props.planForConduct?.completionAndDismantling ?? {}) as any}
                onUpdate={handleCompletionAndDismantlingChange}
            />
            <STBAttachmentsSection stbAttachment={(props.planForConduct?.stbAttachments ?? {}) as any} />
            <TaskInfoSection taskInfo={(props.planForConduct?.taskInfo ?? {}) as any} />
        </div>
    );
};

export default PlanForConductTemplate;
